const EMPTY = "—";

export const formatCount = (value) => Number(value || 0).toLocaleString();

export const formatDecimal = (value, digits = 2) =>
  Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

export const formatPercent = (ratio, digits = 2) =>
  `${formatDecimal(Number(ratio || 0) * 100, digits)}%`;

export const formatDurationMs = (milliseconds) => {
  if (milliseconds === null || milliseconds === undefined) return EMPTY;
  if (milliseconds < 1000) return `${Math.round(milliseconds)} ms`;
  const totalSeconds = milliseconds / 1000;
  if (totalSeconds < 60) return `${totalSeconds.toFixed(1)} s`;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.round(totalSeconds % 60);
  return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
};

export const formatDateTime = (iso) => {
  if (!iso) return EMPTY;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return EMPTY;
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatDayLabel = (dayKey) => {
  const [year, month, day] = dayKey.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString(
    undefined,
    { timeZone: "UTC", day: "numeric", month: "short", year: "numeric" },
  );
};

export const computeDelta = (current, previous, { asPoints = false } = {}) => {
  if (previous === null || previous === undefined) return null;
  if (current === 0 && previous === 0) return null;

  if (asPoints) {
    const points = (current - previous) * 100;
    if (Math.abs(points) < 0.005) return { direction: "flat", label: "0 pp" };
    return {
      direction: points > 0 ? "up" : "down",
      label: `${points > 0 ? "+" : "-"}${formatDecimal(Math.abs(points), 2)} pp`,
    };
  }

  if (previous === 0) {
    return current === 0
      ? { direction: "flat", label: "0%" }
      : { direction: "new", label: "New" };
  }

  const percent = ((current - previous) / previous) * 100;
  if (Math.abs(percent) < 0.05) return { direction: "flat", label: "0%" };
  const digits = Math.abs(percent) >= 100 ? 0 : 1;
  return {
    direction: percent > 0 ? "up" : "down",
    label: `${percent > 0 ? "+" : "-"}${formatDecimal(Math.abs(percent), digits)}%`,
  };
};
